import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const element = this.element;
        this.clone = '';
        element.addEventListener("click", () => {
            if (element.classList.contains("video-playing")) {
                return;
            }
            this.clone = element.cloneNode(true);
            element.classList.add("video-playing");
            const videoUrl = element.getAttribute("data-video-src");
            element.innerHTML = `<video class="video-autoplay" autoplay controls controlsList="nodownload" playsinline preload="auto"><source src="${videoUrl}" type="video/mp4"></video>`;
        });
    }
}
